module.exports = __webpack_public_path__ + "v.no1.9b292b2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/v.no1.jpg
// module id = S5pH
// module chunks = 0